import styled from 'styled-components';

import {Device} from '../../../constants';

const StyledCtaCaptionContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 1em;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media screen and ${Device.tablet} {
    text-align: center;
  }

  @media screen and ${Device.mobileL} {
    padding: 0.75em;
    font-size: 0.75em;
    text-align: center;
  }

  p {
    color: #99cdfb;
    text-transform: none !important;
    font-size: 0.8em;
    font-family: OpenSans, sans-serif !important;
  }
  img {
    width: 16px;
    height: 16px;
    margin-right: 0.5em;
  }
`;

export default StyledCtaCaptionContainer;
